import React from "react";
import clsx from "clsx";

import {
  Loader,
  HyphenIcon,
  Accordion,
  AccordionHeader,
  AccordionHeaderName,
} from "@transfr-inc/dashboard-components";

import { services } from "../../../../dependencies";
import { useApiRequest } from "../../../../utils/http-client";

import "./disciplines.section.scss";

export const DisciplinesSection = ({ organization, className }) => {
  const { organizationService } = services;
  const { response: data, loading } = useApiRequest(() =>
    organizationService.getOrganizationDisciplines(organization?.code)
  );

  return (
    <div
      className={clsx("disciplines-section", loading && "loader", className)}
    >
      <h2>
        Disciplines{" "}
        <span className="badge">
          {data?.disciplines.length ?? <HyphenIcon />}
        </span>
      </h2>

      <div className="content-section">
        {data?.disciplines.map((d) => (
          <Accordion key={`discipline-${d.id}`}>
            <AccordionHeader>
              <AccordionHeaderName>
                {d.name}
              </AccordionHeaderName>
            </AccordionHeader>
          </Accordion>
        ))}
        {loading && <Loader overlay fixed />}
      </div>
    </div>
  );
};
